//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import api from '@/api/index'
    import userApi from '@/api/user'
    import examApi from '@/api/exam'
    import {
        Const
    } from '@/consts'
    import utils from '@/utils'
    import footerNav from '@/components/footer/footer'
    import finished from '@/assets/images/课程_已完成.png'
    import continueAble from '@/assets/images/课程_暂停.png'
    import disAble from '@/assets/images/课程_不可播放.png'
    import playAble from '@/assets/images/课程_播放.png'
    import personIcon from '@/assets/images/personal/个人中心_完善资料_头像.png'
    import Dialog from '@/components/dialog'
    import {MessageBox, Toast, Indicator} from 'mint-ui'
    import utilsFunc from '@/utils/utils.js'
    export default {
        data() {
            return {
                //申请考试
                examDate: "",
                examRoomResp: "",
                loadExamRoom: false,
                questionType: '',//当前问题类型
                examRoomId: '',
                questionTypeVal1: '',//当前问题类型-改变后的
                popupVisible1: false,//问题类型弹框
                //popupSlots:[{values:['安全帽','手环','头盔','pad']}],
                popupSlots: [],
                courseLevelList:[],
                //申请考试结束
                scoreInfo: {},
                openPicker: false,
                FINISHED: '#2766ff',
                CONTINUE: 'blue',
                ADDLEARN: 'blue',
                OVERTIMELEARN: 'blue',
                MISSLEARN: 'blue',
                finalScore: '',
                myProgress: '',
                mySchool: '',
                userSigupCourse: true,
                row: 4,
                introOpen: false,
                showTop: false,
                playsinline: true,
                isSup: false,
                supCount: '',
                appraiseContent: '',
                loaded: false,
                query: {},
                courseid: '',
                data: {},
                stage: '',
                result: {},
                logined: false,
                myProgressInfo: {},
                isCompleted: false,
                // playerOptions: {
                //   playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
                //   autoplay: false, // 如果true,浏览器准备好时开始回放。
                //   muted: false, // 默认情况下将会消除任何音频。
                //   loop: false, // 导致视频一结束就重新开始。
                //   preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                //   language: 'zh-CN',
                //   aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                //   fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                //   sources: [{
                //     type: '',
                //     src: '' // 你的视频地址（必填）
                //   }],
                //   poster: '', // 你的封面地址
                //   // width: document.documentElement.clientWidth,
                //   notSupportedMessage: '此视频暂无法播放，请稍后再试', // 许覆盖Video.js无法播放媒体源时显示的默认信息。
                //   controlBar: {
                //     timeDivider: true,
                //     durationDisplay: true,
                //     remainingTimeDisplay: false,
                //     fullscreenToggle: true // 全屏按钮
                //   }
                // },
                selected: '1',
                chapter1: false,
                chapter2: false,
                chapter3: false,
                level: '',
                lessonList: [],
                replyList: [],
                pagesize: 10,
                pageno: -1,
                allLoaded: false,
                dialogConfig: {
                    title: '温馨提示',
                    tips: '',
                    content: '若您属于人社部门公布的享受免费培训的人群，报名该课程后，您的学习过程将受到监管。若您非该类人群，则无需报名，直接学习即可。',
                    confirm: '确认选择',
                    cancel: '我要再考虑一下'
                },
                inputDialogConfig: {
                    title: '评论',
                    confirm: '确定',
                    casncle: '取消'
                }
            }
        },
        filters: {
            getIcon: function (value) {
                if (value === 'FREE') {
                    return playAble
                } else if (value === 'FINISHED') {
                    return finished
                } else if (value === 'CONTINUE' || value === 'EXAMINATION') {
                    return continueAble
                } else if (value === 'DISABLED') {
                    return disAble
                }
            }
        },
        mounted() {
            this.sysAlert()
            this.getCourse()
            this.getCourseTypeLevelList4CourseId();
            // alert(this.$route.params.id);
        },
        created() {
            // 判断登录状态
            this.logined = utils.checkUserLogined()
            this.courseid = this.$route.query.courseid
            // 获取课程详情
        },
        computed: {
            personIcon() {
                return personIcon
            },
            apllyexamDialogConfig: function () {
                var config = {
                    title: '考试申请',
                    closable: true
                }
                config.confirm = '提交申请'
                config.cancel = '暂不申请'
                return config
            }
        },

        components: {
            footerNav,
            myDialog: Dialog,
            examDialog: Dialog
        },

        methods: {
            getCourseTypeLevelList4CourseId() {
                console.log(this.courseid);
                // 获取首页数据(轮播图
                api.getCourseTypeLevelList4CourseId({
                    params: {courseId:this.courseid}
                }).then(resp => {
                    this.courseLevelList = resp.data;
                }).catch((resp) => {
                    console.log(resp);
                })
            },
            /**
             * 打开问题类型的弹框
             */
            openQuestionType() {
                this.popupVisible1 = true;
            },
            applysubm() {
                examApi.setTestId({params: {courseId: this.courseid, testId: this.examRoomId}}).then(resp => {
                    // debugger
                    if (resp.status == "SUCCESS") {
                        MessageBox({
                            message: "您已提交考试申请",
                            title: '温馨提示',
                            confirmButtonText: '确定',
                            confirmButtonClass: 'button'
                        })
                    } else {
                        MessageBox({
                            message: resp.msg,
                            title: '温馨提示',
                            confirmButtonText: '确定',
                            confirmButtonClass: 'button'
                        })
                    }
                    this.$refs.apllyexamDialog.close();
                }).catch(resp => {
                    Toast(resp.message)
                })
            },
            // 问题类型弹框点击确认
            popupOk() {

                this.popupVisible1 = false;

            },
            //问题类型的弹框picker值发生改变
            onValuesChange(picker, values) {
                console.log(values, "111111111111111111111111111")
                this.examRoomId = values[0].code;
                this.questionType = values[0].name;
                if (this.loadExamRoom) {
                    this.examRoomResp.forEach((item, index) => {
                        if (item.id == this.examRoomId) {
                            this.examDate = item.exambegaintime + "-" + item.examendtime
                        }
                    })
                }
            },

            sysAlert() {
            },
            changeSup() {
                if (this.logined) {
                    api.changeSup({
                        params: {
                            courseid: this.courseid
                        }
                    }).then(resp => {
                        this.isSup = resp.result
                        this.getSupCount()
                    })
                } else {
                    utils.save('USER_TYPE', 'TOURIST')// 用户类型-游客
                    MessageBox.confirm('您还没有登录,现在要登录吗?').then(action => {
                        this.$router.push({
                            path: '/login'
                        })
                    })
                }
            },
            appraise() {
                this.$refs.inputDialog.close()
                api.addreply({
                    params: {
                        courseid: this.courseid,
                        content: this.appraiseContent
                    }
                }).then(resp => {
                    Toast('提交成功,请等待管理员审核')
                    this.replyList = []
                    this.getReplyList(false)
                })
            },
            inputDialogOpen() {
                if (this.logined) {
                    this.$refs.inputDialog.open()
                    // document.querySelector('.video-player video').style.display = 'none'
                    this.appraiseContent = ''
                } else {
                    utils.save('USER_TYPE', 'TOURIST')// 用户类型-游客
                    MessageBox.confirm('您还没有登录,现在要登录吗?').then(action => {
                        this.$router.push({
                            path: '/login'
                        })
                    })
                }
            },
            apply() {
                Indicator.open({
                    text: '报名中...',
                    spinnerType: 'fading-circle'
                });
                this.$refs.myDialog.close()
                api.startLearning({
                    params: {
                        courseid: this.courseid
                    }
                }).then(resp => {
                    Indicator.close();
                    if (resp.status === 'SUCCESS') {
                        Toast('报名成功')
                        this.getCourse()
                    }
                }).catch(resp => {
                    Toast(resp.message || resp.msg)
                    Indicator.close();
                })
            },
            goBack() {
                let from = this.$route.query && this.$route.query.from
                if (from) {
                    this.$router.push({
                        path: '/' + from.replace(/-/g, '/')
                    })
                } else {
                    this.$router.push({
                        path: '/index'
                    })
                }
            },
            queryCourseDetail() {
                let _this = this
                //this.stage = 'DENGDAIKAOSHIZHONG'
                // document.querySelector('.video-player video').style.display = 'none'
                console.log("点击3")
                if (this.stage === 'SIGNUP' || this.stage == null || this.result.progressVal > 11) {
                    if (!this.userSigupCourse) {
                        Toast('请联系学校或老师进行专业报名！')
                        return false;
                    }
                    if (this.logined) {
                        userApi.checkIsSignUped({
                            params: {
                                courseId: this.courseid
                            }
                        }).then((resp) => {
                            console.log(resp);
                            if (resp[Const.RESP_STATUS] == Const.STATUS_OK) {
                                const result = resp[Const.RESP_RESULT] || {}
                                if (result.mycourse) {
                                    this.dialogConfig.tips = '您目前正在学习<' + result.mycourse.title + '>,学习进程已达' + result.myProgress.totalProgress + '%,如果继续报名,该学习进程将停滞,请谨慎操作!!!';
                                }
                                // 我要报名
                                this.$refs.myDialog.open()
                            } else {
                                Toast(resp.message || resp.msg || '专业报名异常')
                            }
                        }).catch((resp) => {
                            // Toast(resp[Const.RESP_MESSAGE]);
                            Toast(resp.message || resp.msg || '专业报名异常')

                        })

                    } else {
                        utils.save('USER_TYPE', 'TOURIST')// 用户类型-游客
                        MessageBox.confirm('您还没有登录,现在要登录吗?').then(action => {
                            this.$router.push({
                                path: '/login'
                            })
                        })
                    }
                } else if (this.stage === 'CONTINUE') {
                    //无有效课程的时候检测下状态
                    let isOver = true
                    for (let j in this.lessonList) {
                        if (this.lessonList[j].stage === 'CONTINUE' || this.lessonList[j].stage === 'EXAMINATION') {
                            console.log(this.lessonList[j])
                            this.play((this.lessonList[j]))
                            isOver = false
                        }
                    }
                    if (isOver) {
                        userApi.checkIsOverLesson({
                            params: {
                                courseId: this.courseid
                            }
                        }).then((resp) => {
                            //刷新页面
                            Toast(resp.message || resp.msg || '无有效课程,返回首页')
                            this.$router.push({path: '/index'})
                        }).catch((resp) => {
                            Toast(resp.message || resp.msg || '进度异常，请重试')
                        })
                    }

                } else if (this.stage === 'EXAMINATION') {
                    if (this.showTop) {
                        if (!this.isCompleted) {
                            MessageBox.confirm('您尚未完善资料,是否现在完善资料').then(resp => {
                                this.completeInfo()
                            })
                        } else {
                            this.$router.push({
                                path: '/exam/start',
                                query: {
                                    courseId: this.courseid
                                }
                            })
                        }
                    } else {
                        Toast('选修课无需考试')
                        console.log("选修课无需考试")
                    }
                    // 开始考试
                } else if (this.stage === 'PRACTICAL') {
                    // 实训报名
                    this.$router.push({
                        path: '/personal/school/list',
                        query: {
                            courseId: this.courseid
                        }
                    })
                } else if (this.stage === 'PARTICIPATION') {
                    // 参与实训
                    this.$router.push({
                        path: '/personal/school/punchcardPlus',
                        schoolId: this.mySchool.schoolid
                    })
                } else if (this.stage === 'FINALSCORE') {
                    // 最终成绩
                    this.getFinalScore()
                } else if (this.stage === 'SHENGQINGKAOSHI' || this.stage === 'BOHUISHENGQINGKAOSHI') {
                    //申请考试
                    examApi.getTestInfo({params: {courseId: this.courseid}}).then(resp => {

                        _this.examRoomResp = resp.result
                        let arr = []
                        //arr.push({"examendtime":"2021-03-28 23:59:59","examRoomId":"1616659241075","exambegaintime":"2020-03-18 00:00:00","name":"测试1"})
                        _this.examRoomResp.forEach((item, index) => {
                            console.log(item.examRoomId, "111111111111111111111111111111111111")
                            arr.push({code: item.id, name: item.name})
                        });
                        _this.popupSlots = [{values: arr}]
                        _this.$refs.apllyexamDialog.open()
                        _this.openPicker = true
                        _this.loadExamRoom = true


                    }).catch(resp => {
                        Toast(resp.msg)
                    })
                    // let params={courseId:this.$route.query.courseid}
                    // let respo={"status":"SUCCESS","message":"获取成功","result":[{"examRoomId":'adsddad11',"examStartDate":"2021-3-28","examEndDate":"2021-4-28"},{"examRoomId":'adsdasdad11',"examStartDate":"2021-3-25","examEndDate":"2021-5-22"},{"examRoomId":'adsdasd',"examStartDate":"2021-2-18","examEndDate":"2021-7-18"}],"inform":null,"redirecturl":null}
                } else if (this.stage === 'KAOSHISHENGHEZHONG') {
                    MessageBox({
                        message: "考试申请正在审核中",
                        title: '温馨提示',
                        confirmButtonText: '确定',
                        confirmButtonClass: 'button'
                    })
                } else if (this.stage === 'DENGDAIKAOSHIZHONG') {
                    examApi.getDengDaiKaoShiZhongInfo({params: {courseId: this.courseid}}).then(resp => {
                        if (resp.status == "SUCCESS") {
                            if (resp.message == "审核通过")
                                MessageBox({
                                    message: '<div style="text-align:left;width:200px;margin:auto;">您的考试申请已通过，等待考试</div><div>考场：<span style="font-size:22px;color:#2766ff">' + resp.result.name + '</span></div><div>考试时间：<span style="font-size:22px;color:#2766ff">' + resp.result.exambegaintime + " - " + resp.result.examendtime + '</span></div></div>',
                                    title: '温馨提示',
                                    confirmButtonText: '确定',
                                    confirmButtonClass: 'button'
                                })
                        } else if (resp.message == "审核未通过") {
                            MessageBox({
                                message: '<div style="text-align:left;width:200px;margin:auto;">您的考试申请未通过</div><div>未通过原因：<span style="font-size:22px;color:#2766ff">' + resp.result.remark + '</span></div><div>您可以再次申请考试</div></div>',
                                title: '温馨提示',
                                confirmButtonText: '确定',
                                confirmButtonClass: 'button'
                            })
                        }
                    }).catch(resp => {
                        Toast(resp.message)
                    })
                }
            },
            completeInfo() {
                const msgText = '<div class="text-justify" style="line-height: 25px;">该信息将用于在通过考试后、报考学校时生成纸质报名表，若信息不符可能导致报名失败，请您依照真实情况填写。其中姓名、性别、身份证号码、家庭住址上传完身份证后会自动生成，无法手动填写。<div>'

                MessageBox.confirm(msgText, '温馨提示', {
                    confirmButtonText: '我已知晓',
                    cancelButtonText: '我要再考虑一下',
                    closeOnClickModal: false,
                    type: 'info'
                }).then(action => {
                    //
                    this.$router.push({
                        path: '/personal/setting/complete',
                        query: {
                            from: 'index-courseInfo?courseid=' + this.courseid
                        }
                    })
                }).catch(() => {

                })
            },
            getCourse() {
                api.getCourse(this.initParams()).then(resp => {
                    console.log(resp.stagetxt)
                    if (resp.result.stage === 'BOHUISHENGQINGKAOSHI' || resp.result.stage === 'DENGDAIKAOSHIZHONG') {
                        MessageBox({
                            message: "考试申请被驳回原因如下：" + resp.result.audiourl,
                            title: '温馨提示',
                            confirmButtonText: '确定',
                            confirmButtonClass: 'button'
                        })
                    }
                    this.initPage(resp)
                })
            },
            getAnotherLevel(oldLevel) {
                api.getAnotherLevel({
                    params: {
                        courseid: this.courseid,
                        courseleveltype: this.level
                    }
                }).then(resp => {
                    this.initPage(resp)
                }).catch(resp => {
                    this.level = oldLevel
                    Toast(resp.message)
                })
            },
            // 获取最终成绩的
            getFinalScore() {
                api.getFinalScore().then(resp => {
                    console.log(resp)
                    this.scoreInfo = resp.result
                    let message = '<div style="text-align:left;width:200px;margin:auto;"><div>考试成绩：<span style="font-size:22px;color:#2766ff">' + this.scoreInfo.examscore +
                        '</span></div><div>实训成绩：<span style="font-size:22px;color:#2766ff">' + this.scoreInfo.exercisescore +
                        '</span></div><div>最终成绩：<span style="font-size:22px;color:#2766ff">' + this.scoreInfo.finalscore + '</span></div></div>'
                    MessageBox({
                        title: this.scoreInfo.title,
                        message: message,
                        showCancelButton: false
                    })
                }).catch(resp => {
                    Toast(resp.message)
                })
            },
            getLessonList() {
                api.getLessonList({
                    params: {
                        courseid: this.courseid
                    }
                }).then(resp => {
                    this.lessonList = resp.result
                })
            },
            getReplyList(firstLoad) {
                api.getReplyList({
                    params: {
                        courseid: this.courseid,
                        pageno: this.pageno,
                        pagesize: this.pagesize,
                        order: 0
                    }
                }).then(resp => {
                    if (resp.result.length === 0) {
                        this.allLoaded = true
                    } else {
                        this.replyList = this.replyList.concat(resp.result)
                    }
                    if (!firstLoad) {
                        this.$refs.loadMore.onBottomLoaded()
                    }
                })
            },
            getSupCount() {
                api.getSupCount({
                    params: {
                        courseid: this.courseid
                    }
                }).then(resp => {
                    this.supCount = resp.result
                })
            },
            getSupSign() {
                api.isSup({
                    params: {
                        courseid: this.courseid
                    }
                }).then(resp => {
                    this.isSup = resp.result
                })
            },
            getInfoDetail() {
                if (utils.getUserToken()) {
                    userApi.getInfoDetail({
                        params: {
                            courseId: this.courseid
                        }
                    }).then((resp) => {
                        const result = resp[Const.RESP_RESULT] || {}
                        this.isCompleted = result.isCompleted;
                        if (result.mycourse.length > 0 && this.courseid == result.mycourse[0].courseid) {

                            this.myProgressInfo = result.myProgress || {}
                            // 进度
                            this.processMyProgress((result.mystatus || {}).stage)
                            // 学校
                            this.mySchool = result.myschool || {}
                        }
                        this.userSigupCourse = result.userSigupCourse;
                    }).catch((resp) => {
                        // Toast(resp[Const.RESP_MESSAGE]);
                        if (resp.statusCode == '200') {
                            Toast(resp[Const.RESP_MESSAGE] || '获取信息失败')
                        }
                    })
                }
            },
            processMyProgress(stage) {
                switch (stage + '') {
                    case 'SIGNUP':
                        this.myProgress = 0
                        break
                    case 'CONTINUE':
                        this.myProgress = 1
                        break
                    case 'COMPLETE':
                        this.myProgress = 1
                        break
                    case 'EXAMINATION':
                        this.myProgress = 2
                        break
                    case 'PRACTICAL':
                        this.myProgress = 3
                        break
                    case 'PARTICIPATION':
                        this.myProgress = 4
                        break
                    case 'FINALSCORE':
                        this.myProgress = 4
                        break
                    case 'GRADUATION':
                        this.myProgress = 5
                        break
                    default:
                        this.myProgress = 0
                        break
                }
            },
            initPage(resp) {
                this.replyList = []
                this.row = 4
                this.pageno = -1
                this.allLoaded = false
                this.result = {}
                this.$nextTick(() => {
                    this.result = resp.result
                    if (this.result) {
                        if (this.result.coursetype === 'PROFESSIONAL' || this.result.coursetype === 'PUBLIC') {
                            this.showTop = true
                        }
                        this.courseid = resp.result.courseid
                        this.$route.query.courseid = this.courseid
                        this.stage = resp.result.stage
                        // this.playerOptions.poster = resp.result.coverurl
                        // this.playerOptions.sources[0].src = resp.result.videourl || 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'
                        this.level = this.result.courseleveltype
                        this.getInfoDetail()
                    }
                    this.getLessonList()
                    this.getSupCount()


                    if (this.logined) {
                        this.getSupSign()
                    }
                    this.loadMore(true)
                    this.loaded = true
                })
            },
            initParams() {

                this.query = {
                    params: {
                        courseid: this.courseid
                    }
                }
                return this.query
            },
            itemClick(index) {
                this.lessonList[index].open = !this.lessonList[index].open
                console.log(this.lessonList[index].open)
                // 强刷
                this.$forceUpdate()
            },
            cut(level) {
                if (level !== this.level) {
                    let oldLevel = this.level
                    this.level = level
                    this.getAnotherLevel(oldLevel)
                }
            },
            loadMore(firstLoad) {
                if (firstLoad == '') {
                    firstLoad = false
                }
                this.pageno = this.pageno + 1
                if (!this.allLoaded) {
                    this.getReplyList(firstLoad)
                }
            },
            handleBottomChange(status) {
                console.log(status)
            },
            // 播放
            play(citem) {
                console.log(citem)
                //debugger

                if (this.stage === 'SIGNUP') {
                    // MessageBox.alert('本课程需要您报名，请问您要报名吗?').then(action => {
                    //     this.queryCourseDetail();
                    // })
                    MessageBox.confirm('<div style="height:100px;line-height:100px">本课程需要您报名，请问您要报名吗?</div>').then(resp => {
                        this.queryCourseDetail();
                    })
                    return
                }
                if (citem.stage === 'FREE' || citem.stage === 'FINISHED'
                    || citem.stage === 'CONTINUE' || citem.stage === 'ADDLEARN'
                    || citem.stage === 'MISSLEARN'
                    || citem.stage === 'OVERTIMELEARN'
                ) {
                    this.$router.push({
                        path: '/course/lesson',
                        query: {
                            lessonid: citem.lessonid,
                            courseid: this.courseid
                        }
                    })
                } else if (citem.stage === 'DISABLED') {
                    return null
                } else if (citem.stage === 'FINISHED_NOSTUDY') {
                    Toast('该课程已学完！')
                    return null
                } else if (citem.stage === 'EXAMINATION') {
                    MessageBox.confirm('<div style="height:100px;line-height:100px">是否开始章节测试?</div>').then(resp => {
                        this.$router.push({
                            path: '/course/lesson',
                            query: {
                                lessonid: citem.lessonid,
                                courseid: this.courseid
                            }
                        })
                    })

                }
            },
            onCancel() {
                // console.log(document.querySelector('.video-player video'))
                // document.querySelector('.video-player video').style.display = ''
            }
        }
    }



// WEBPACK FOOTER //
// ./src/view/index/course/courseInfo.vue